import dayjs from "dayjs";
import { Client } from "../components/client/types";

// Window = 60 days BEFORE reference date → 150 days AFTER (210 days total)
export const getRenewalStatus = (referenceDate?: string | null) => {
  if (!referenceDate || referenceDate === "-") return null;

  const ref = dayjs(referenceDate);
  if (!ref.isValid()) return null;

  const today = dayjs().startOf("day");
  const windowOpen = ref.subtract(60, "day");
  const windowClose = ref.add(150, "day");

  if (today.isBefore(windowOpen)) return null;

  if (today.isBefore(ref) || today.isSame(ref, "day")) {
    const daysLeft = ref.diff(today, "day");
    return {
      color: "#1565c0",
      bgColor: "rgba(25,118,210,0.07)",
      borderColor: "#1976d2",
      label: "Renewal Window Open",
      tooltip: `📋 Renewal window is open — reference date in ${daysLeft} day${daysLeft !== 1 ? "s" : ""} (${ref.format("MMM D, YYYY")})\nWindow: ${windowOpen.format("MMM D")} → ${windowClose.format("MMM D, YYYY")}`,
    };
  }

  if (!today.isAfter(windowClose)) {
    const daysPast = today.diff(ref, "day");
    const daysLeft = windowClose.diff(today, "day");
    return {
      color: "#1565c0",
      bgColor: "rgba(25,118,210,0.12)",
      borderColor: "#1976d2",
      label: "Renewal Active",
      tooltip: `📋 Reference date passed ${daysPast} day${daysPast !== 1 ? "s" : ""} ago (${ref.format("MMM D, YYYY")})\n${daysLeft} day${daysLeft !== 1 ? "s" : ""} remaining in renewal window (closes ${windowClose.format("MMM D, YYYY")})`,
    };
  }

  const daysExpired = today.diff(windowClose, "day");
  return {
    color: "#1565c0",
    bgColor: "rgba(25,118,210,0.04)",
    borderColor: "#90caf9",
    label: "Window Expired",
    tooltip: `📋 Renewal window expired ${daysExpired} day${daysExpired !== 1 ? "s" : ""} ago (${windowClose.format("MMM D, YYYY")})\nConsider updating the reference date.`,
  };
};

/** Get the effective reference date from a client object (ofa.referenceDate preferred) */
export const getClientReferenceDate = (client: Client): string | null => {
  if (client.ofa?.referenceDate) return client.ofa.referenceDate;
  return null;
};
